export default class {
    constructor (game) {
        this.game = game
        this.scene = game.getScene()
        this.game.onTick(() => this.updateScore())
    }

    updateScore () {
        let score = this.game.getPlayer().getScore()
        this.scene.writeText(
            `Score: ${score}`,
            this.scene.getWidth() / 2,
            this.scene.getHeight() - 10,
            'white',
        )
    }
}
